<template>
  <div class="messForm">
    <el-form ref="form" :model="form" label-width="100px" v-if="!twoCodeTeam&&!$privatization" :rules="rules">
      <el-form-item label="用户名 :">
        <el-col :span="10">
          <el-input v-model="form.aliasName" @change="nameChange"></el-input>
        </el-col>
      </el-form-item>
      <p>*用户名长度不超过16个字符</p>
      <el-form-item label="角色 :" v-if="ifForm == '1'">
        <el-col :span="10">
          <el-select class="fieldSel" v-model="form.roleId" placeholder="请选择所属角色" @change="nameChange">
            <el-option v-for="item in SelfRoleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="擅长领域 :" v-show="roleLevel == 3">
        <el-col :span="10">
          <el-select class="fieldSel" v-model="form.domain" multiple collapse-tags :multiple-limit="3"
            placeholder="请选择擅长领域" @change="nameChange">
            <el-option v-for="(item, index) in domainList" :key="index" :label="item.dataDesc" :value="item.dataKey">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="擅长语言 :" v-show="roleLevel == 3">
        <el-col :span="10">
          <el-select class="fieldSel" v-model="form.langDesc" multiple collapse-tags :multiple-limit="3"
            placeholder="请选择擅长语言" @change="nameChange">
            <el-option v-for="(item, index) in langDescList" :key="index" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="手机号 :" v-show="roleLevel == 3">
        <el-col :span="10">
          <el-input v-model="form.loginPhone" @change="nameChange"></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <!-- 私有start -->
    <el-form ref="form" :model="form" label-width="100px" v-if="this.ifForm == '1' && $privatization">
      <el-form-item label="用户名 :">
        <el-col :span="10">
          <el-input v-model="form.loginPhone" @change="nameChange"></el-input>
        </el-col>
      </el-form-item>
      <p>*用户名长度不超过16个字符</p>
      <el-form-item label="姓名 :">
        <el-col :span="10">
          <el-input v-model="form.aliasName" @change="nameChange"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="初始密码 :">
        <el-col :span="10">
          <el-input disabled v-model="form.password" @change="nameChange"></el-input>
        </el-col>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" label-width="100px" v-if="this.ifForm != '1' && $privatization">
      <el-form-item label="姓名 :">
        <el-col :span="10">
          <el-input v-model="form.aliasName" @change="updateChange"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="重置密码 :">
        <el-col :span="10">
          <el-checkbox v-model="checked" @change="updateChange">选中将重置此用户密码为“123456”</el-checkbox>
        </el-col>
      </el-form-item>
    </el-form>
    <!-- 私有end -->
    <div v-if="twoCodeTeam" class="codeImg">
      <img style="width: 140px;height: 140px;" :src="wxImgUrl" alt="微信二维码" />
    </div>
    <p v-if="twoCodeTeam" class="twoCodeTxt">
      二维码可以下载到本地发送给成员。（有效期24小时）
      <a :href="wxImgUrl" download>下载二维码</a>
    </p>
  </div>
</template>

<script>
// import myTitle from '@/common/title.vue'

export default {
  name: "messTeam",
  // ifForm为 1 则显示角色
  props: ["ifForm", "isCall", "twoCodeTeam", "wxImgUrl"],
  data () {
    return {
      ruleForm: {
        name: "",
        region: "",
        loginPhone: ''
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 1, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" }
        ],
        loginPhone: [{ required: true, validator: isPhone, trigger: "blur" }],
      },
      SelfRoleList: [],
      roleLevel: "",
      form: {
        aliasName: "",
        roleId: "",
        langDesc: "",
        roleLevel: "",
        domain: [],
        contact: "",
        loginPhone: "",
        password: "123456"
      },
      fileArr: [],
      visibleLef: false,
      visibleRig: false,
      ifqq: "false",
      langDescList: [],
      domainList: [],
      checked: false
    };
  },
  components: {},
  watch: {
    isCall () {
      if (this.ifForm == "1") {
        this.callFileArr();
      }
    },
    twoCode () {
      var that = this;
      if (that.twoCodeTeam == true) {
      }
    }
  },
  created () {
    this.getSelfRoleList();
    this.getDomainList();
    this.getLangDescList();
    if (!this.ifForm == "1") {
      let form = this.$store.state.updateUser || "";
      let arr = [];
      if (form.langTagList.length > 0) {
        // this.form.langDesc = form.langTagList[0].tagCode;
        form.langTagList.forEach(item => {
          arr.push(item.tagCode);
        });
      }
      let ary = [];
      if (form.domainTagList.length > 0) {
        form.domainTagList.forEach(item => {
          ary.push(item.tagCode);
        });
      }
      this.form.aliasName = form.aliasName;
      this.roleLevel = form.roleLevel;
      this.form.roleId = form.roleId;
      this.form.domain = ary;
      this.form.langDesc = arr;
      this.form.loginPhone = form.loginPhone || undefined
    }
  },
  updated () {
    let obj = {
      aliasName: this.form.aliasName,
      roleId: this.form.roleId,
      langDesc: [],
      domain: [],
      loginPhone: this.form.loginPhone,
      password: this.form.password
    };
    if (!this.$privatization) {
      this.langDescList.forEach(item => {
        //console.log(this.form.langDesc); 可以获取选中的语言
        this.form.langDesc.forEach(i => {
          if (item.code === i) {
            obj.langDesc.push({
              tagCode: item.code,
              tagName: item.name
            });
          }
        });
        //console.log(obj.langDesc);  可以获取选中的语言
      });

      this.domainList.forEach(item => {
        this.form.domain.forEach(i => {
          if (item.dataKey === i) {
            obj.domain.push({
              tagCode: item.dataKey,
              tagName: item.dataDesc
            });
          }
        });
      });
    }
    this.$store.commit("setUpdateUser", obj);
  },
  methods: {
    // 私有化修改
    updateChange () {
      let data = { aliasName: this.form.aliasName, flag: this.checked }
      this.$emit("getMessForm", data);
    },
    // 获取领域
    getDomainList () {
      var that = this;
      var params = {
        dataType: "domain"
      };
      this.catReq1Service("/api/v1/common/queryOptionList", params).then(
        function (response) {
          if (!response.success) {
            return;
          }
          that.domainList = response.result;
        }
      );
    },
    // 获取语言对列表
    getLangDescList () {
      var that = this;
      this.catReq1Service("/api/v1/common/queryAllLang").then(function (
        response
      ) {
        if (!response.success) {
          return;
        }
        that.langDescList = response.result;
      });
    },
    getSelfRoleList () {
      var that = this;
      this.catReq1Service("/api/v1/role/querySelfRoleList").then(function (
        response
      ) {
        if (response.resultCode === "1") {
          that.SelfRoleList = response.result;
          that.$privatization ? that.form.roleId = response.result[0].id : '';
        }
      });
    },
    // 修改名称
    nameChange () {
      var that = this;
      // that.form.forEach(item=>{
      //  console.log(item)
      // })

      let obj = {
        langTagList: [],
        domainTagList: []
      };
      if (!this.$privatization) {
        that.SelfRoleList.forEach(item => {
          if (item.id === that.form.roleId) {
            this.roleLevel = item.roleLevel;
          }
        });
        that.langDescList.forEach(item => {
          that.form.langDesc.forEach(i => {
            if (item.code === i) {
              obj.langTagList.push({
                tagCode: item.code,
                tagName: item.name
              });
            }
          });
        });
        that.domainList.forEach(item => {
          that.form.domain.forEach(i => {
            if (item.dataKey === i) {
              obj.domainTagList.push({
                tagCode: item.dataKey,
                tagName: item.dataDesc
              });
            }
          });
        });
      }
      obj.aliasName = that.form.aliasName;
      obj.roleId = that.form.roleId;
      obj.loginPhone = that.form.loginPhone || undefined;
      obj.password = that.form.password;
      obj.langDesc = that.form.langDesc;
      if (this.roleLevel === 2) {
        obj.langTagList = [];
        obj.domainTagList = [];
      }
      that.$emit("getMessForm", obj);
    },
    // 清空
    callFileArr () {
      this.fileArr = [];
      if (this.$privatization) {
        this.form.aliasName = "";
        this.form.loginPhone = "";
      } else {
        this.form = {
          aliasName: "",
          roleId: "",
          langDesc: "",
          domain: [],
          roleLevel: ""
        };
      }
      this.$emit("getMessForm", this.form);
    }
  }

};
function isPhone (rule, value, next) {
  var reg = /^1\d{10}$/;
  if (value === "" || value == void 0) {
    next("*请输入手机号");
  } else if (!reg.test(value)) {
    next("*请输入正确的手机号");
  } else {
    next();
  }
}
</script>
<style lang="less" scoped>
.messForm {
  // width: 693px;
  margin: 0 53px;
  .el-form {
    p {
      position: relative;
      top: -20px;
      left: -20px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(128, 128, 128, 1);
      margin-left: 60px;
    }
  }
  .codeImg {
    // 二维码样式
    width: 140px;
    height: 140px;
    margin: 0 auto;
  }
  .twoCodeTxt {
    margin: 0 auto;
    margin-top: 20px;
    width: 193px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(69, 69, 69, 1);
    a {
      color: #489ef6;
    }
  }
  .el-icon-right {
    // 语言对icon大小
    font-size: 18px !important;
  }
  /deep/.el-input {
    width: 202px !important;
  }
  /deep/.el-inputel-form {
    width: 693px !important ;
  }
}
</style>
<style lang="less"></style>
